import useRequestResultsForPrint from "../result/useRequestResultsForPrint";

export const RequestResultsForPrintInitializer = ({
	namespace,
}: {
	namespace: string;
}) => {
	useRequestResultsForPrint(namespace);

	return null;
};
